
    <!-- Header Placeholder -->
    <app-header></app-header>
    
    <main class="container mx-auto px-4 pb-6 lg:px-6 lg:py-8">
        <!-- Hero Section -->
        <section class="mt-4 mb-8 lg:mb-12">
            <div class="bg-gradient-to-r from-wattpad-primary to-wattpad-secondary rounded-xl p-6 lg:p-8 text-white">
                <div class="flex flex-col lg:flex-row gap-6 items-center">
                    <div class="lg:w-1/3 flex justify-center">
                        <div class="bg-white/20 p-6 rounded-full w-48 h-48 flex items-center justify-center">
                            <i class="fas fa-headset text-6xl"></i>
                        </div>
                    </div>
                    <div class="lg:w-2/3 text-center lg:text-left">
                        <h1 class="text-2xl lg:text-4xl font-bold mb-2">📞 Contact Us — Funtel Stories</h1>
                        <p class="text-xl lg:text-2xl mb-4 font-medium">We're here to help!</p>
                        
                        <p class="text-sm lg:text-base mb-6">
                            Whether you're a reader, listener, creator, or partner — we'd love to hear from you.
                            For questions, feedback, support issues, business inquiries, or collaboration opportunities, 
                            please reach out using the details below or submit the contact form.
                        </p>
                        
                        <div class="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                            <a href="#contact-form" class="bg-white text-wattpad-primary px-8 py-3 rounded-full font-bold hover:bg-gray-100 transition-colors text-lg">
                                Send a Message
                            </a>
                            <a href="#contact-info" class="bg-white/20 text-white px-8 py-3 rounded-full font-medium hover:bg-white/30 transition-colors text-lg">
                                Contact Details
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Contact Information Cards -->
        <section class="mb-8 lg:mb-12" id="contact-info">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <!-- General Support Card -->
                <div class="contact-card bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-gray-700">
                    <div class="flex items-start mb-4">
                        <div class="bg-wattpad-primary/10 p-3 rounded-lg mr-4">
                            <i class="fas fa-question-circle text-wattpad-primary text-xl"></i>
                        </div>
                        <div>
                            <h3 class="font-bold text-lg mb-1 text-wattpad-primary">General Support</h3>
                            <p class="text-gray-600 dark:text-gray-400 text-sm">
                                Have questions about using the platform, your account, or payment-related concerns?
                            </p>
                        </div>
                    </div>
                    <div class="mt-4">
                        <div class="flex items-center mb-2">
                            <i class="fas fa-envelope text-wattpad-primary mr-2"></i>
                            <a href="mailto:support&#64;funtelstudio.com" class="text-wattpad-primary hover:underline">support&#64;funtelstudio.com</a>
                        </div>
                        <div class="flex items-center text-sm text-gray-600 dark:text-gray-400">
                            <i class="far fa-clock text-wattpad-primary mr-2"></i>
                            <span>Available Mon–Sat | 10:00 AM – 7:00 PM IST</span>
                        </div>
                    </div>
                </div>

                <!-- Content & Creator Queries Card -->
                <div class="contact-card bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-gray-700">
                    <div class="flex items-start mb-4">
                        <div class="bg-wattpad-accent/10 p-3 rounded-lg mr-4">
                            <i class="fas fa-pen-nib text-wattpad-accent text-xl"></i>
                        </div>
                        <div>
                            <h3 class="font-bold text-lg mb-1 text-wattpad-accent">Content & Creator Queries</h3>
                            <p class="text-gray-600 dark:text-gray-400 text-sm">
                                Interested in publishing your story or content on Funtel Stories?
                            </p>
                        </div>
                    </div>
                    <div class="mt-4">
                        <div class="flex items-center">
                            <i class="fas fa-envelope text-wattpad-accent mr-2"></i>
                            <a href="mailto:creators&#64;funtelstudio.com" class="text-wattpad-accent hover:underline">creators&#64;funtelstudio.com</a>
                        </div>
                    </div>
                </div>

                <!-- Partnerships & Business Card -->
                <div class="contact-card bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-100 dark:border-gray-700">
                    <div class="flex items-start mb-4">
                        <div class="bg-wattpad-secondary/10 p-3 rounded-lg mr-4">
                            <i class="fas fa-handshake text-wattpad-secondary text-xl"></i>
                        </div>
                        <div>
                            <h3 class="font-bold text-lg mb-1 text-wattpad-secondary">Partnerships & Business</h3>
                            <p class="text-gray-600 dark:text-gray-400 text-sm">
                                Collaborations, branding, or corporate communications
                            </p>
                        </div>
                    </div>
                    <div class="mt-4">
                        <div class="flex items-center">
                            <i class="fas fa-envelope text-wattpad-secondary mr-2"></i>
                            <a href="mailto:business&#64;funtelstudio.com" class="text-wattpad-secondary hover:underline">business&#64;funtelstudio.com</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Contact Form & Additional Info -->
        <section class="mb-8 lg:mb-12">
            <div class="flex flex-col lg:flex-row gap-8">
                <!-- Contact Form -->
                <div class="lg:w-2/3" id="contact-form">
                    <div class="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm">
                        <h2 class="text-xl lg:text-2xl font-bold mb-6 text-wattpad-primary">Send us a message</h2>
                        
                        <form id="contactForm">
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                <div>
                                    <label for="name" class="block text-sm font-medium mb-2">Your Name *</label>
                                    <input type="text" id="name" name="name" required 
                                           class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg form-input focus:outline-none focus:border-wattpad-primary bg-white dark:bg-gray-700">
                                </div>
                                <div>
                                    <label for="email" class="block text-sm font-medium mb-2">Email Address *</label>
                                    <input type="email" id="email" name="email" required 
                                           class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg form-input focus:outline-none focus:border-wattpad-primary bg-white dark:bg-gray-700">
                                </div>
                            </div>
                            
                            <div class="mb-4">
                                <label for="subject" class="block text-sm font-medium mb-2">Subject *</label>
                                <input type="text" id="subject" name="subject" required 
                                       class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg form-input focus:outline-none focus:border-wattpad-primary bg-white dark:bg-gray-700">
                            </div>
                            
                            <div class="mb-4">
                                <label for="category" class="block text-sm font-medium mb-2">Category *</label>
                                <select id="category" name="category" required 
                                        class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg form-input focus:outline-none focus:border-wattpad-primary bg-white dark:bg-gray-700">
                                    <option value="">Select a category</option>
                                    <option value="general">General Support</option>
                                    <option value="creator">Content & Creator Queries</option>
                                    <option value="business">Partnerships & Business</option>
                                    <option value="feedback">Feedback</option>
                                    <option value="technical">Technical Issue</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>
                            
                            <div class="mb-6">
                                <label for="message" class="block text-sm font-medium mb-2">Your Message *</label>
                                <textarea id="message" name="message" rows="5" required 
                                          class="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg form-input focus:outline-none focus:border-wattpad-primary bg-white dark:bg-gray-700"></textarea>
                            </div>
                            
                            <button type="submit" class="w-full bg-wattpad-primary text-white py-3 px-6 rounded-lg font-bold submit-btn">
                                Send Message
                            </button>
                        </form>
                    </div>
                </div>
                
                <!-- Additional Information -->
                <div class="lg:w-1/3">
                    <!-- Office Address -->
                    <div class="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm mb-6">
                        <h3 class="text-lg font-bold mb-4 text-wattpad-primary flex items-center">
                            <i class="fas fa-map-marker-alt mr-2"></i> Office Address
                        </h3>
                        <div class="flex items-start">
                            <div class="mr-3 text-wattpad-primary">
                                <i class="fas fa-building"></i>
                            </div>
                            <div>
                                <p class="font-medium">Funtel Studio</p>
                                <p class="text-gray-600 dark:text-gray-400">Thane / Mumbai, Maharashtra, India</p>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Response Time -->
                    <div class="bg-wattpad-accent/10 border border-wattpad-accent/20 rounded-xl p-6">
                        <div class="flex items-start">
                            <i class="fas fa-clock text-wattpad-accent text-xl mt-1 mr-4"></i>
                            <div>
                                <h3 class="font-bold text-lg mb-2 text-wattpad-accent">Response Time</h3>
                                <p class="text-wattpad-dark dark:text-gray-300">
                                    We aim to respond within <span class="font-bold">24–48 business hours</span>.
                                </p>
                                <p class="text-wattpad-dark dark:text-gray-300 mt-2 text-sm">
                                    For urgent matters, please mention "URGENT" in your subject line.
                                </p>
                            </div>
                        </div>
                    </div>
                    
                   
                </div>
            </div>
        </section>

        <!-- Social Media & Community -->
        <section class="mb-8 lg:mb-12">
            <div class="bg-gradient-to-r from-wattpad-primary to-wattpad-secondary rounded-xl p-6 lg:p-8 text-white text-center">
                <h2 class="text-xl lg:text-2xl font-bold mb-4">Join Our Community</h2>
                <p class="mb-6 max-w-2xl mx-auto">
                    Stay connected with Funtel Stories through our social media channels for updates, 
                    writing tips, featured stories, and community events.
                </p>
                
                <div class="flex justify-center space-x-6">
                    <a href="#" class="bg-white/20 p-3 rounded-full hover:bg-white/30 transition-colors">
                        <i class="fab fa-facebook-f text-xl"></i>
                    </a>
                    <a href="#" class="bg-white/20 p-3 rounded-full hover:bg-white/30 transition-colors">
                        <i class="fab fa-twitter text-xl"></i>
                    </a>
                    <a href="#" class="bg-white/20 p-3 rounded-full hover:bg-white/30 transition-colors">
                        <i class="fab fa-instagram text-xl"></i>
                    </a>
                    <a href="#" class="bg-white/20 p-3 rounded-full hover:bg-white/30 transition-colors">
                        <i class="fab fa-linkedin-in text-xl"></i>
                    </a>
                    <a href="#" class="bg-white/20 p-3 rounded-full hover:bg-white/30 transition-colors">
                        <i class="fab fa-youtube text-xl"></i>
                    </a>
                </div>
            </div>
        </section>
    </main>

    